import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { interval, timer } from 'rxjs';
import { AuthService } from './core/auth/auth.service';
import { ApplicationsService } from './modules/applications/applications.service';
import { Subject } from 'rxjs';
import { filter, takeUntil, mergeMap } from 'rxjs/operators';
import { MatDrawer } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from 'environments/environment';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    @ViewChild('innerDrawerInfoWindow') innerDrawerInfoWindow: MatDrawer;
    drawerMode: 'over' | 'side' = 'side';
    drawerOpened: boolean = false;
    title: any;
    text: any;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private authService: AuthService
        , private router: Router
        , private appService: ApplicationsService
        , private _changeDetectorRef: ChangeDetectorRef
    ) {

        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            takeUntil(this._unsubscribeAll)
        ).subscribe((res) => {
            this.closeSideDrawer();
        });

        //repeat every 20 minutes
        timer(0, 20 * 60 * 1000).subscribe(() => {
            this.authService.check().subscribe((isLogged) => {
                if (!isLogged) return;
                this.authService.signInUsingToken().subscribe(() => {
                });
            });
        });

        this.appService.openHelpSideDrawer$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((res: any) => {
                if (res) {
                    this.title = res?.title;
                    this.text = res?.text;
                    this.drawerOpened = true;
                }
                // Mark for check
                this._changeDetectorRef.markForCheck();
            });
    }

    ngOnInit(): void {

    }

    closeSideDrawer(): void {
        this.drawerOpened = false;
        this.appService.closedHelpSideDrawer.next(true);
        this.innerDrawerInfoWindow.close();
    }
}
